<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
  mounted() {},
  methods: {},
  watch: {
    // 监听路由设置tag标签名
    $route: {
      handler(to) {
        this.$nextTick(() => {
          if (to.meta.title) {
            document.title = `${to.meta.title}`;
          } else {
            document.title = `加载中`;
          }
        });
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>
<style>
/* .el-table {
  overflow: scroll;
} */
</style>
